// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"ehq_mainContainer__1SOlf","illustration":"ehq_illustration__3Lv_C","innerBox":"ehq_innerBox__1ug7P","footnote":"ehq_footnote__2nrQc"};